import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import download from 'downloadjs';
import { UserSikdaeGivenForm, UserSikdaeGivenResult } from 'components/UserSikdaeGivenList';
import { LoadingBar } from 'components/Commons';

import * as cm_action from 'actions/commons';
import * as usg_action from 'actions/usage';
import cm from 'helpers/commons';
import toastr from 'helpers/toastr';
import storage from 'helpers/storage';
import api from 'config';

import ExcelRequestCompleteModal from './ExcelRequestCompleteModal';

moment.tz.setDefault('Asia/Seoul');

class UserSikdaeGivenList extends Component {
  constructor() {
    super();

    this.state = {
      // page: 1,
      // pagerow: 100,

      userId: null,
      modal: false,
      modalPage: 1,
      modalPagerow: 10,
      sDate: null,
      eDate: null,
      totalcount: null,
      loading: false,
      params: null,
      hasSearched: false, // 조회 버튼 클릭 여부 체크
      hasNetworkError: false, // 네트워크 에러 발생 여부 체크

      isLoading: false,
      isVisbles: false
    };
  }

  async componentWillMount() {
    cm.propsInit(this.props);

    const { cmAPI } = this.props;

    await cmAPI.sikdaeGroupList();
  }

  componentDidMount() {
    cm.mainTitle('사용자별 식대 내역');
    // 초기 API 호출 제거 - 조회 버튼 클릭 시에만 API 호출
  }

  componentDidCatch(error, errorInfo) {
    console.log('###### error : ', error);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { sikList } = this.props;
    const { loading, modal, isLoading, isVisbles } = this.state;
    const sikListChange = sikList !== nextProps.sikList;
    const lodingChange = loading !== nextState.loading;
    const modalChange = nextState.modal !== modal;
    const btnLoading = isLoading !== nextState.isLoading;
    const open = isVisbles !== nextState.isVisbles;
    return lodingChange || sikListChange || modalChange || btnLoading || open;
  }

  // 확인
  submitForm = async (e) => {
    e.preventDefault();

    const { dateCheck } = this.props;

    if (!dateCheck.isValue.isState) {
      toastr('top-right', 'warning', dateCheck.isValue.message);
      return;
    }
    await this.setState({ page: 1 });
    this.userSikdaeList();
  };

  handleEntSubmit = (e) => {
    if (e.key === 'Enter') {
      this.submitForm(e);
    }
  };

  // 검색 값들을 모아 전송 후 리스트 받기
  userSikdaeList = async (_params) => {
    await this.setState({ loading: true, hasSearched: true, hasNetworkError: false });
    const { page, pagerow, totalcount } = this.state;
    const { date, depth, groupIdx, text } = this.props;

    const params = {
      keyword: text ? text.value : null,
      orgCode: depth ? depth.value : null,
      groupid: groupIdx ? groupIdx.value : null,
      // page: _params ? _params.page : page,
      // pagerow: _params ? _params.pagerow : pagerow,
      // pagerow: _params ? _params.pagerow : pagerow,
      totalcount: page !== 1 ? totalcount : null,
      startdate: date
        ? date.sDate
        : moment()
            .startOf('month')
            .format('LL'),
      enddate: date ? date.eDate : moment().format('LL')
    };

    try {
      const { usgAPI } = this.props;
      if (params.page === 1) {
      }
      const total = usgAPI.userSikTotal(params);
      const list = usgAPI.userSikList(params);

      await Promise.all([total, list]);

      const { sikList } = this.props;
      if (sikList && sikList.status && sikList.status === 200) {
        // 상세내역 불러오기 할 때 필요한 데이터
        this.setState({
          sDate: params.startdate,
          eDate: params.enddate,
          params,
          totalcount: sikList && sikList.data && sikList.data.paging ? sikList.data.paging.totalcount : null
        });
      }

      const { cmAPI } = this.props;
      cmAPI.changeExcel({
        excel: params
      });
    } catch (error) {
      console.error('API 호출 오류:', error);
      // 네트워크 에러 상태 설정
      this.setState({ hasNetworkError: true });
    } finally {
      // API 성공/실패 여부와 관계없이 로딩 해제
      this.setState({ loading: false });
    }
  };

  // 페이지 이동
  pageClick = async (pageNum) => {
    await this.setState({ page: pageNum });
    this.userSikdaeList();
  };

  openModal = async (id) => {
    await this.setState({
      userId: id,
      modal: true,
      modalPage: 1
    });

    this.UserDtlList();
  };

  closeModal = () => {
    this.setState({
      userId: null,
      modal: false
    });
  };

  dtlPageClick = async (page) => {
    await this.setState({ modalPage: page });
    this.UserDtlList();
  };

  UserDtlList = () => {
    const { usgAPI } = this.props;
    const { userId, modalPage, modalPagerow, sDate, eDate } = this.state;
    const params = {
      page: modalPage,
      pagerow: modalPagerow,
      startdate: sDate,
      enddate: eDate
    };

    usgAPI.userSikDtl(userId, params);
  };

  // 모달(식대내역 상세) 엑셀 다운로드
  downloadExcel = async () => {
    const com = storage.get('company');
    const { userCount } = storage.get('userCount');
    const { userId, sDate, eDate } = this.state;
    const { cmAPI } = this.props;

    let header = null;
    const url = this.props.history.location.pathname;
    const isAsyncExcelDown =
      url === '/main/userSikdaeGivenList' ||
      url === '/main/sikdaeGivenList' ||
      url === '/main/DetailedSikdae' ||
      url === '/main/DetailedSikdaePro' ||
      url === '/main/DetailedSikdaeSamsungSds';

    try {
      await this.setState({
        downloadExcelFile: '',
        isLoading: true
      });

      if (isAsyncExcelDown && userCount && userCount >= 1000) {
        setTimeout(() => {
          this.setState({ isLoading: false, isVisbles: true });
        }, 5000);
      }

      const params = {
        com,
        excel: {
          url: `/coupon/v1/user/${userId}/download`,
          method: 'get'
        },
        excelResult: {
          excel: {
            startdate: sDate,
            enddate: eDate
          }
        }
      };

      await cmAPI.excelDownload(params);

      if (isAsyncExcelDown && userCount < 1000) {
        const { excelDownloadReault } = this.props;

        if (excelDownloadReault) {
          header = excelDownloadReault.headers['content-disposition'];
          header = header.split('=');

          download(excelDownloadReault.data, decodeURIComponent(header[1]));
          toastr('top-right', 'success', ' 엑셀파일 생성 완료 되었습니다.');
        }
      }
    } catch (e) {
      const result = e.response;

      if (result && result.data) {
        const { status } = result;

        toastr('top-right', 'error', ` 엑셀파일 생성에 실패 하였습니다.(${String(status)})`);
      }
      console.log('###### ExcelDownLoad : ', e);
    } finally {
      if (!isAsyncExcelDown || userCount < 1000) {
        await this.setState({ isLoading: false });
      }
    }
  };

  onExcelDownList = () => {
    const { history } = this.props;
    this.setState({ isVisbles: false });
    history.push('/main/excelDownloadList');
  };

  close = async () => {
    await this.setState({ isVisbles: false });
  };

  render() {
    const { modal, loading, params, isVisbles, isLoading, hasSearched, hasNetworkError } = this.state;
    const formFn = {
      submitForm: this.submitForm,
      handleEntSubmit: this.handleEntSubmit
    };
    const resultFn = {
      // pageClick      : this.pageClick,
      userSikdaeList: this.userSikdaeList,
      openModal: this.openModal,
      modal,
      closeModal: this.closeModal,
      pageClickModal: this.dtlPageClick,
      downloadExcel: this.downloadExcel,
      isLoading,
      hasSearched,
      hasNetworkError
    };

    let loadingBar = '';
    if (loading) {
      loadingBar = <LoadingBar />;
    }

    return (
      <main className="usgl">
        {loadingBar}

        <UserSikdaeGivenForm formFn={formFn} />
        <UserSikdaeGivenResult resultFn={resultFn} params={params} />

        <ExcelRequestCompleteModal
          open={isVisbles}
          close={() => this.setState({ isVisbles: false })}
          onExcelDownList={this.onExcelDownList}
        />
      </main>
    );
  }
}

UserSikdaeGivenList = connect(
  (state) => ({
    // result of function call
    sikdaeGroup: state.commons.sikdaeGroup,
    division: state.commons.division,
    sikList: state.usage.userSikdaeList,
    sikDetail: state.usage.userSikDetail,

    // commons
    date: state.commons.date,
    dateCheck: state.commons.dateCheck,
    depth: state.commons.depth,
    groupIdx: state.commons.group,
    text: state.commons.text,

    excelDownloadReault: state.commons.excelDownload
  }),
  (dispatch) => ({
    cmAPI: bindActionCreators(
      {
        sikdaeGroupList: cm_action.SikdaeGroupList,
        changeExcel: cm_action.ChangeExcel,
        excelDownload: cm_action.ExcelDownload
      },
      dispatch
    ),

    usgAPI: bindActionCreators(
      {
        userSikList: usg_action.UserSikdaeGivenList,
        userSikTotal: usg_action.UserSikdaeGivenTotal,
        userSikDtl: usg_action.UserSikdaeGivenDtl
      },
      dispatch
    )
  })
)(UserSikdaeGivenList);

export default UserSikdaeGivenList;
